const generateRandomID = (length = 10) =>
  Array(length).fill().map(
    () => Math.floor(Math.random() * 36).toString(36),
  ).join('');

export default generateRandomID;
